import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { Platform } from '@ionic/angular';
//import { Marker } from '@ionic-native/google-maps';
//import { GoogleMap } from '@capacitor/google-maps';
import { ILocation } from 'src/app/services/location.service';
import { Geolocation } from '@capacitor/geolocation'; // new package used here
import { LoaderService } from 'src/app/shared/services/loader.service';
import { PhonePipe } from 'src/app/shared/pipes/phone.pipe';
//import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Browser } from '@capacitor/browser';
import { ImageService } from 'src/app/shared/services/image.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
declare var google: any;

export interface IGeoposition {
  latitude: number;
  longitude: number;
}

@Component({
    selector: 'locations-map',
    templateUrl: './locations-map.component.html',
    styleUrls: ['./locations-map.component.scss'],
    standalone: false
})
export class LocationsMapComponent implements OnInit {
  @ViewChild('mapContainer', {read: ElementRef, static: false}) mapRef: ElementRef;
  map: any; // GoogleMap;
  infoWindow: any;

  @Input() locations: ILocation[];
  @Input() topframed: boolean;

  position: IGeoposition;
  imageUrl: string;
  //imageUrl: SafeUrl;
  selectedLocation: ILocation = null;
  locationIconToShow: any;
  constructor(private alert: AlertService,
    //private translate: TranslateService,
    private phonePipe: PhonePipe,
    private setting: SettingService,
    private imageService: ImageService,
    private platform: Platform,
    private loader: LoaderService,
    //private geolocation: Geolocation,
    private ref: ChangeDetectorRef,
    //public inAppBrowser: InAppBrowser
    private translationService: TranslationService,
    private sanitizer: DomSanitizer
  ) { }

  async ngOnInit() {

    // Only access NavParams if running inside a modal
    /*
    const navParams = this.injector.get(NavParams, null);

    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }
    */


    await this.platform.ready;

    this.getLocation();
  }

  /*
  async getLocation() {
    const loader = await this.loader.create();
    await loader.present();

    this.geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 20000 })
      .then(position => {
        this.position = position;

        this.loadMap();
      })
      .catch((reason) => {

        let messageKey;
        if (reason.code == 1) //PositionError.PERMISSION_DENIED)
          messageKey = 'Geolocation.PermissionDenied';
        else if (reason.code == 2) //PositionError.POSITION_UNAVAILABLE)
          messageKey = 'Geolocation.PositionUnavailable';
        else if (reason.code == 3) //PositionError.TIMEOUT)
          messageKey = 'Geolocation.Timeout';

        if (messageKey)
          this.alert.showTranslate(messageKey);
        else
          this.alert.showUnexpectedErrorMsg();
      })
      .finally(() => {
        loader.dismiss();
      });
  }
  */

  async getLocation() {
    const loader = await this.loader.create();
    await loader.present();

    try {
      const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 5000 });

      // Assign to your interface
      this.position = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      } as IGeoposition;

      // Proceed with your map logic
      await this.fetchLocationIcon()

      this.loadMap();

    } catch (reason: any) {

      try {
        const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 5000 });

        // Assign to your interface
        this.position = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        } as IGeoposition;

        // Proceed with your map logic
        await this.fetchLocationIcon()
        this.loadMap();

      } catch (reason2: any) {
        let messageKey: string | undefined;

        // Map Capacitor error codes to your translation keys
        if (reason2.code === 1) messageKey = 'Geolocation.PermissionDenied';
        else if (reason2.code === 2) messageKey = 'Geolocation.PositionUnavailable';
        else if (reason2.code === 3) messageKey = 'Geolocation.Timeout';

        if (messageKey) this.alert.showTranslate(messageKey);
        else this.alert.showUnexpectedErrorMsg();

      }

    } finally {
      loader.dismiss();
    }
  }

  fetchLocationIcon()
  {

    return new Promise((resolve, reject) => {
      if (this.setting.configuration?.locationIconShortName && this.setting.configuration?.locationIconShortName != "") {
    
        this.setting.getFile(this.setting.configuration?.locationIconShortName).subscribe(data => {
          this.imageService.createImageFromBlob(data)
            .subscribe((buffer) => {
              this.locationIconToShow = buffer;
              resolve('');
            });
        }, error => {
          console.log(error);
          resolve('');
        });
      } else {
        console.log("No configured icon found. using google's default image");
        resolve('');
      }
    });
  }
  
  loadMap() {

    /*Environment.setEnv({
      'API_KEY_FOR_BROWSER_RELEASE': this.setting.getGoogleApiKey(),
      'API_KEY_FOR_BROWSER_DEBUG': this.setting.getGoogleApiKey()
    });*/

    /*let mapOptions: GoogleMapOptions = {
      camera: {
        target: {
          lat: this.position.coords.latitude,
          lng: this.position.coords.longitude,
        },
        zoom: 14,
        tilt: 30,
      }
    };*/


    ////////////////////////////////////////////////////////////////////////
    //preparing the google map's coloring

    console.log("start loading the map");

    var styles = [];

    var waterColor = "";
    var roadColor = "";
    var poiColor = "";
    var landscapeColor = "";

    if(this.setting.configuration.uIoptions?.googleMapColoring) {
      waterColor = this.setting.configuration.uIoptions?.googleMapColoring.waterColor;
      roadColor = this.setting.configuration.uIoptions?.googleMapColoring.roadColor;
      poiColor = this.setting.configuration.uIoptions?.googleMapColoring.poiColor;
      landscapeColor = this.setting.configuration.uIoptions?.googleMapColoring.landscapeColor;
    }

    console.log("setting map colors");

    if(waterColor) {
      styles.push(
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{ "color": waterColor }]
        }
      );
    }

    if(roadColor) {
      styles.push(
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{ "color": roadColor }]
        }
      );
    }

    if(poiColor) {
      styles.push(
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [{ "color": poiColor }]
        }
      );
    }

    if(landscapeColor) {
      styles.push(
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [{ "color": landscapeColor }]
        }
      );
    }

    ////////////////////////////////////////////////////////////////////////

    let mapOptions = {
      //center: new google.maps.LatLng(this.position.coords.latitude, this.position.coords.longitude),
      center: new google.maps.LatLng(this.position.latitude, this.position.longitude),
      zoom: 14,
      tilt: 30,
      disableDefaultUI: true,
      styles: styles
    };
 
    console.log("setting map opetions");
    console.log(mapOptions);
    

    // this.map = GoogleMaps.create('map', mapOptions);
    this.map = new google.maps.Map(this.mapRef.nativeElement, mapOptions);

    console.log("setting the map");
    console.log(this.map);

    this.map.addListener('click', () => {
      this.selectedLocation = null;
      this.ref.detectChanges();
    });

    console.log("added event listener");

    /*this.map.on(GoogleMapsEvent.MAP_CLICK).subscribe(() => {
      this.selectedLocation = null;
      this.ref.detectChanges();
    });*/


    const imageFileIcon = {
      url: this.locationIconToShow, 
      scaledSize: new google.maps.Size(30, 45), // scaled size
    }
    const imageUrlIcon = {
      url:  this.setting.locationIcon,
      scaledSize: new google.maps.Size(30, 45),
    }

    console.log("setting up icons");
    console.log(imageFileIcon);
    console.log(imageUrlIcon);
    
    for (let location of this.locations) {

      let marker = new google.maps.Marker({
        position: new google.maps.LatLng(location.Latitude, location.Longitude),
        title: location.DisplayName,
        icon: this.locationIconToShow && !this.setting.useLocationIconUrl() ?  imageFileIcon : (this.setting.locationIcon  ? imageUrlIcon : null),
        animation: google.maps.Animation.DROP,
        location: location
      })

      marker.setMap(this.map);

      //marker.set('location', location);
      marker.addListener('click', async () => {
        this.selectedLocation = marker.location;
        let currentTime=`<div style="text-align: center"><div style="display: flex;  flex-direction: column-reverse; justify-content: center"><div><ion-badge color="danger">${this.translationService.translate('Store.OnlineNotAvailable')}</ion-badge></div><div style="align-self:center"><span><a href="tel:${this.selectedLocation.Phone}" style="text-decoration: none; color: blue; margin-left: 4px">${this.phonePipe.transform(this.selectedLocation.Phone)}</a></span></div></div></div>`
        
        if (this.selectedLocation.ImageUrl)
        {
          this.imageUrl = this.selectedLocation.ImageUrl;
          //this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
          //this.imageUrl = await this.imageToDataUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
        }
        else if(this.setting.logo)
        {
          this.imageUrl = this.setting.logo;
          //this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
          //this.imageUrl = await this.imageToDataUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
        }
        else 
        {
          this.imageUrl = "assets/imgs/location/default.png";
        }
        
        if(this.selectedLocation.__currentDayHours)
        {
          currentTime = `<div style="text-align: center"><div style="display: flex;  flex-direction: column-reverse;justify-content: center"> <div style="align-self:center"> <span style="font-size: 10px;">${ this.selectedLocation.__currentDayHours.OpenTime }-${ this.selectedLocation.__currentDayHours.CloseTime }</span></div> <div style="align-self:center"><span><a href="tel:${this.selectedLocation.Phone}" style="text-decoration: none; color: blue; margin-left: 4px">${this.phonePipe.transform(this.selectedLocation.Phone)}</a></span></div>  </div></div>`
        }
        const contentString2 = `<div style="display: flex; justify-content: center"><img style="max-width: 240px;" src="${this.imageUrl}" ></div>
          <div>
          <div style="text-align: center"><h2 style="margin: 0px;">${this.selectedLocation.DisplayName}</h2></div>
          <div style="text-align: center">${this.selectedLocation.FormattedAddress}</div>
          ${currentTime}
          <div style="display: flex; justify-content: center; padding-bottom: 8px"><ion-button id="directions" size="small" *ngIf="position" style="margin-bottom: 0;">Directions</ion-button></div>
          </div>
        `
        //let inAppBrowser=this.inAppBrowser;
        //let directionUrl=`https://www.google.com/maps/dir/?api=1&origin=${this.position.coords.latitude},${this.position.coords.longitude}&destination=${this.selectedLocation.Latitude},${this.selectedLocation.Longitude}`
        let directionUrl = `https://www.google.com/maps/dir/?api=1&origin=${this.position.latitude},${this.position.longitude}&destination=${this.selectedLocation.Latitude},${this.selectedLocation.Longitude}`;
    
        this.infoWindow = new google.maps.InfoWindow({
          content: contentString2,
        });
      
       

      google.maps.event.addListener(this.infoWindow, 'domready', ()=> {
        let closeButton = document.querySelector('.gm-ui-hover-effect') as HTMLElement;
        closeButton.style.marginRight="2px"
        document.getElementById("directions").addEventListener("click",getDirections);
      })

      const getDirections = async () =>{
        /*
        const browser = inAppBrowser.create(directionUrl, '_system', {
          location: 'no',
        });
        */
        await Browser.open({
          url: directionUrl,
          windowName: '_blank', // Capacitor only supports '_blank' or '_self', '_system' is handled by default behavior
        });
      }

        this.infoWindow.open({
           anchor: marker,
           map: this.map,
           shouldFocus: false,
         });
          this.ref.detectChanges();
      });

      /*marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
          this.selectedLocation = marker.get('location');
          this.ref.detectChanges();
      });*/
    }

    console.log("looped and setting every position on the map");
  }

  private async imageToDataUrl(url: string): Promise<string> {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to load image: ${response.status}`);
    }

    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result as string);
      };

      reader.onerror = reject;

      reader.readAsDataURL(blob);
    });
  }
}
